import { useEffect } from 'react';

import { useEventCallback } from '@shared/utils/hooks/useEventCallback';
import { withWindow } from '@shared/utils/withWindow';

import type { ComponentHealthState } from '../types';
import { StateType } from '../types';

export function useLoadTimeoutEffect(componentHealthState: ComponentHealthState, onTimeout: () => void, timeout?: number) {
  // Stable callback function ref to prevent the below useEffect from rerunning
  // whenever `onTimeout` param changes.
  const stableOnTimeout = useEventCallback(onTimeout);

  useEffect(() => {
    if (!timeout) return;
    let timeoutHandle: number;

    if (componentHealthState.type === StateType.Loading) {
      withWindow(global => {
        timeoutHandle = global.setTimeout(() => {
          stableOnTimeout();
        }, timeout);
      });
    }

    return () => {
      withWindow(global => {
        global.clearTimeout(timeoutHandle);
      });
    };
  }, [componentHealthState.type, stableOnTimeout, timeout]);
}
